import { memo, useContext } from "react";
import PropTypes from "prop-types";
import BackgroundProgressiveImg from "app/pages/.shared/BackgroundProgressiveImg";
import RelativeLink from "app/pages/.shared/RelativeLink";
import AppGlobalsContext from "app/AppGlobalsContext";
import "./FaqHomeCategory.scss";
import { FormattedMessage } from "react-intl";

const IMG_SIZES = {
	large: { width: 241, height: 120 },
	xlarge: { width: 241, height: 120 },
	medium: { width: 710, height: 354 },
	small: { width: 500, height: 249 },
};

const FaqHomeCategory = ({
	categoryId,
	categoryName,
	categoryPicture,
	categoryThumbnail,
	subCategories,
}) => {
	const { resolution } = useContext(AppGlobalsContext);

	const subCategoriestoDisplay = subCategories.slice(0, 4);

	return (
		<div className="faq-home-category">
			<div className="faq-home-category__picture">
				<BackgroundProgressiveImg
					src={categoryPicture}
					thumbnail={categoryThumbnail}
					resolution={resolution}
					sizes={IMG_SIZES}
				/>
			</div>
			<div className="faq-home-category__content">
				<div className="faq-home-category__name">
					<RelativeLink
						to={{
							pathname: `/faq/category/${categoryId}`,
						}}
						className="faq-home-category__link"
					>
						<i className="icon icon--chevron" /> {categoryName}
					</RelativeLink>
				</div>
				<div className="faq-home-category__subcategories">
					{subCategoriestoDisplay.map(subCategory => {
						return (
							<div key={subCategory.id} className="faq-home-category__subcategory">
								<RelativeLink
									to={{
										pathname: `/faq/category/${categoryId}/subcategory/${
											subCategory.id
										}`,
									}}
									className="faq-home-category__link"
								>
									{subCategory.name}
								</RelativeLink>
							</div>
						);
					})}
					<div className="faq-home-category__see-all">
						<RelativeLink to={{ pathname: `/faq/category/${categoryId}` }}>
							<FormattedMessage id="faq.home.categories.see.all" /> >
						</RelativeLink>
					</div>
				</div>
			</div>
		</div>
	);
};

FaqHomeCategory.propTypes = {
	categoryId: PropTypes.string,
	categoryPicture: PropTypes.string,
	categoryThumbnail: PropTypes.string,
	categoryName: PropTypes.string,
	subCategories: PropTypes.array,
};

FaqHomeCategory.defaultProps = {
	subCategories: [],
	categoryPicture:
		"https://res.cloudinary.com/perfectstay/image/upload/v1607722775/asset/DESK_cat-generique.jpg",
	categoryThumbnail:
		"/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAgICAgJCAkKCgkNDgwODRMSEBASEx0VFhUWFR0sHCAcHCAcLCcvJiQmLydGNzExN0ZRREBEUWJYWGJ8dnyiotkBCAgICAkICQoKCQ0ODA4NExIQEBITHRUWFRYVHSwcIBwcIBwsJy8mJCYvJ0Y3MTE3RlFEQERRYlhYYnx2fKKi2f/AABEIABkAMgMBIgACEQEDEQH/xABpAAACAgMBAAAAAAAAAAAAAAACBgABAwQFBxAAAgICAgMBAAAAAAAAAAAAAAECAwURBCESMTQTAQADAQEBAAAAAAAAAAAAAAAAAwQCAQURAAMBAQADAQAAAAAAAAAAAAABAhEDEiExUf/aAAwDAQACEQMRAD8A5uJyd1nJipSPRIz3FCBjsPdTdGTHuppRSZJfi2etyfSYer2ZfIvZrt7mZNiniZXG1KbDbB2C2Ds4MSMmyAbIAYKfIyd1NzTj0bfEy9Vz1vs0Mn7mL2L+qQ7E0yfXNJfdHiGRjK/8zrKXQn0faNkfSFWsw3xp0nv6G2TYJaMFARCiGgP/2Q==",
};

export default memo(FaqHomeCategory);
